var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.05 25.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.525,0A12.525,12.525,0,1,0,25.05,12.525,12.525,12.525,0,0,0,12.525,0Zm4.388,6.831a.446.446,0,0,1,0-.523L18.2,5.263l.017-.015a.7.7,0,0,1,.483-.218.385.385,0,0,1,.277.105l.834.834a.4.4,0,0,1,.1.334.721.721,0,0,1-.215.426l-1.06,1.3a.331.331,0,0,1-.229.082.59.59,0,0,1-.294-.087l-.147-.087L15.24,10.721l-1.095-.947L17,6.978ZM12.22,16.09,8.57,19.74a1.949,1.949,0,0,1-2.756,0L5.2,19.127a1.949,1.949,0,0,1,0-2.756l3.6-3.6a6.867,6.867,0,0,0,.733-.1l2.824,3.263A1.973,1.973,0,0,1,12.22,16.09Zm7.311,2.889a2.278,2.278,0,0,1-1.56.593,1.515,1.515,0,0,1-1.077-.373L9.986,11.216a5.52,5.52,0,0,1-1.73.283,3.47,3.47,0,0,1-2.492-.894,3.591,3.591,0,0,1-1.1-3.756L6.777,8.618l2.147-.245.13-2.032L7.287,4.228a3.505,3.505,0,0,1,1.151-.194,3.858,3.858,0,0,1,2.72,1.178,4.251,4.251,0,0,1,.61,4.223l1.9,1.645.661.572,5.42,4.691A2.1,2.1,0,0,1,19.531,18.979Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportBuilder);
export default __webpack_public_path__ + "static/media/icon-report-builder.b78a3f5e95681532df06059eb8085618.svg";
export { ForwardRef as ReactComponent };